import React from 'react';

const MFAIcon = ({ className = '' }) => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22 0.500244H2C1.46957 0.500244 0.960859 0.710958 0.585786 1.08603C0.210714 1.4611 0 1.96981 0 2.50024V9.84774C0 21.049 9.4775 24.7652 11.375 25.3965C11.7803 25.5343 12.2197 25.5343 12.625 25.3965C14.525 24.7652 24 21.049 24 9.84774V2.50024C24 1.96981 23.7893 1.4611 23.4142 1.08603C23.0391 0.710958 22.5304 0.500244 22 0.500244ZM22 9.84899C22 19.6515 13.7063 22.9265 12 23.4965C10.3088 22.9327 2 19.6602 2 9.84899V2.50024H22V9.84899ZM6.2925 13.2077C6.10486 13.0201 5.99944 12.7656 5.99944 12.5002C5.99944 12.2349 6.10486 11.9804 6.2925 11.7927C6.48014 11.6051 6.73464 11.4997 7 11.4997C7.26536 11.4997 7.51986 11.6051 7.7075 11.7927L10 14.0852L16.2925 7.79274C16.3854 7.69983 16.4957 7.62613 16.6171 7.57585C16.7385 7.52557 16.8686 7.49969 17 7.49969C17.1314 7.49969 17.2615 7.52557 17.3829 7.57585C17.5043 7.62613 17.6146 7.69983 17.7075 7.79274C17.8004 7.88565 17.8741 7.99595 17.9244 8.11735C17.9747 8.23874 18.0006 8.36885 18.0006 8.50024C18.0006 8.63164 17.9747 8.76175 17.9244 8.88314C17.8741 9.00453 17.8004 9.11483 17.7075 9.20774L10.7075 16.2077C10.6146 16.3007 10.5043 16.3745 10.3829 16.4248C10.2615 16.4751 10.1314 16.501 10 16.501C9.86858 16.501 9.73846 16.4751 9.61706 16.4248C9.49566 16.3745 9.38537 16.3007 9.2925 16.2077L6.2925 13.2077Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MFAIcon;
